export const listComponent = {
	inputSearchPlaceholder: "Digite o nome da operação para buscar",
};
